<div [hidden]="!ViewReady">
    <h1 class="mat-h1">Facilitators</h1>
    <div>
        The following table lists the currently active email preferences and settings for each type of IRIS System user, for each type
        of major event which can happen in IRIS. You may check or uncheck settings as necessary in order to customize and tailor the
        desired level of notifications for each type of user in the system.
    </div>
    <div>Please note the following conventions used in this system:</div>
    <ul>
        <li><strong>Instant Email</strong> - Instant emails are emails that will be sent out as soon as the event happens.</li>
        <li>
            <strong>Daily Email</strong> - Daily emails are single emails, typically sent in the afternoon, which contain brief
            summaries of all of the events that took place during the day which were flagged as Daily Email events. Note: If an event
            is flagged as both Instant and Daily Email events, the user will receive two emails for that single event: one immediately
            when it happens, and a daily email later which contains a reference to that event as well.
        </li>
    </ul>
    <table class="mat-table" *ngIf="!SmallDisplay">
        <thead>
            <tr>
                <th rowspan="2">Action / Event</th>
                <th *ngFor="let role of RoleNames" colspan="2">
                    <span>{{ role.RoleDescription }}</span>
                    <mat-icon *ngIf="role.ToolTipInfo" class="primarycolor500 clickicon" (click)="ShowTooltip(role)"> help </mat-icon>
                </th>
            </tr>
            <tr>
                <ng-container *ngFor="let role of RoleNames">
                    <th>Instant Email</th>
                    <th>Daily Email</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let act of PreferencesMatrix; last as $last" [class.bottom-border]="!last">
                <td>{{ act.Action }}</td>
                <ng-container *ngFor="let role of act.Roles">
                    <td class="centered changetracking" [class.changed]="role.InstantChanged">
                        <mat-checkbox [(ngModel)]="role.InstantEmail" (change)="UpdatePreference(role, 'I')"></mat-checkbox>
                    </td>
                    <td class="centered changetracking" [class.changed]="role.DailyChanged">
                        <mat-checkbox [(ngModel)]="role.DailyRoundupEmail" (change)="UpdatePreference(role, 'D')"></mat-checkbox>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </table>
    <div *ngIf="SmallDisplay" fxLayout="column" fxLayoutAlign="start stretch">
        <div class="centered">Actions / Events</div>
        <div fxLayout="column" fxLayoutAlign="start stretch">
            <div
                *ngFor="let act of PreferencesMatrix; even as $even; last as $last"
                [class.primarybackground50]="$even"
                [class.bottom-border]="!$last"
            >
                <div>
                    <strong
                        ><em>{{ act.Action }}</em></strong
                    >
                </div>
                <div *ngFor="let role of act.Roles" class="margin-top" fxLayout="row" fxLayoutAlign="start center">
                    <div fxFlex>{{ role.RoleName }}</div>
                    <mat-form-field appearance="outline" fxFlex="50">
                        <mat-select [(ngModel)]="role.MobileEmail" (selectionChange)="MobileRoleChange(act, role)">
                            <mat-option value="N">No Emails</mat-option>
                            <mat-option value="I">Instant Email</mat-option>
                            <mat-option value="D">Daily Email</mat-option>
                            <mat-option value="B">Instant & Daily Emails</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</div>
